import { ElNotification } from 'element-plus'
import { i18n } from '@/main'

const t = () => i18n.global.t

/** Unified notification service with consistent styling */
export const notify = {
  success: (message: string) => ElNotification({ customClass: 'x-notification__success', title: t()('common.success'), message }),
  error: (message: string) => ElNotification({ customClass: 'x-notification__error', title: t()('common.error'), message }),
  info: (message: string) => ElNotification({ customClass: 'x-notification__info', title: t()('common.info'), message }),
  warning: (message: string) => ElNotification({ customClass: 'x-notification__warning', title: t()('common.warning'), message }),
}
